module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "page_wrap"
  }, [_c('div', {
    staticClass: "view_container"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fb7dfed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 486
// module chunks = 0